import { getAxiosClient } from '../../http.client';
export class SimpleChatClient {
    signature;
    apiClient;
    constructor(signature) {
        this.signature = signature;
    }
    async client() {
        if (this.apiClient) {
            return this.apiClient;
        }
        this.apiClient = getAxiosClient("fluid-web", this.signature);
        return this.apiClient;
    }
    async startConversation(conversationId) {
        const client = await this.client();
        const response = await client.post('/simple-chat/start', { conversationId });
        return response.data;
    }
    async sendMessage(conversationId, message) {
        const client = await this.client();
        const response = await client.post('/simple-chat', { conversationId, message });
        return response.data;
    }
    async deleteConversation(conversationId) {
        const client = await this.client();
        await client.delete(`/simple-chat/${conversationId}`);
    }
}
